import React from "react";
import Typography from "@material-ui/core/Typography";
const Support = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Support
      </Typography>
      <Typography paragraph variant="h5">
        Many choice of getting help.
      </Typography>
      <Typography paragraph variant="body1">
        From community help to premium critical business support, we’re here to
        help.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Knowledge Center.
      </Typography>
      <Typography paragraph variant="body1">
        Find any related Invifo platform documentation in the Knowledge Center
        or raise a ticket for questions or inform any issue. It's free!
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Stack Overflow.
      </Typography>
      <Typography paragraph variant="body1">
        Besides the Invifo Community, Stack Overflow is also visited from time
        to time by the user not only for technical questions but also the
        business process questions.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Custom Platform.
      </Typography>
      <Typography paragraph variant="body1">
        Thinking about having a custom platform special for your company's
        business process? Send us an email and let's discuss together about your
        requirements.
      </Typography>
    </React.Fragment>
  );
};

export default Support;
